export default {
  // Errors
  alreadyConfirmed: 'قبلاً تأیید شده است',
  duplicateEmail: 'ایمیل تکراری است',
  duplicatePhoneNumber: 'شماره همراه تکراری است',
  duplicateUserName: 'نام کاربری تکراری است',
  emailNotFound: 'ایمیل یافت نشد',
  emailNotVerified: 'ایمیل شما تایید نشده است',
  failedToGetUserStatus: 'خطا در دریافت وضعیت کاربر',
  invalidEmail: 'ایمیل نامعتبر است',
  invalidPassword: 'رمز عبور صحیح نیست',
  invalidPhoneNumber: 'شماره همراه نا معتبر است',
  invalidToken: 'توکن نامعتبر می باشد',
  loginFailed: 'نام کاربری یا رمز عبور صحیح نمی باشد',
  notFound: 'حساب کاربری یافت نشد',
  phoneNumberNotVerified: 'شماره همراه شما تایید نشده است',
  userIsNotAdmin: 'فقط مدیران قادر به ورود می باشند',
  userNotFound: 'کاربر پیدا نشد',

  // Words
  account: 'حساب کاربری',
  address: 'آدرس',
  andMaybeYourSpamFolder: 'و احتمالا فولدر اسپم!',
  approved: 'تایید شده',
  basicInfo: 'اطلاعات پایه',
  birthdate: 'تاریخ تولد',
  changeEmail: 'ویرایش ایمیل',
  changePassword: 'ویرایش رمز عبور',
  changePhoneNumber: 'ویرایش شماره همراه',
  confirmationEmailSentTo: 'ایمیل تایید به آدرس "{email}" ارسال گردید.',
  confirmEmail: 'تایید ایمیل',
  confirmPassword: 'تکرار رمز عبور جدید',
  confirmPhoneNumber: 'تایید شماره همراه',
  confirmYourEmail: 'لطفا ایمیل خود را تایید کنید',
  confirmYourPhoneNumber: 'لطفا شماره همراه خود را تایید کنید',
  currentPassword: 'رمز عبور کنونی',
  disapproved: 'تایید نشده',
  editPhoneNumber: 'اصلاح شماره تلفن',
  email: 'ایمیل',
  emailConfirmed: 'تایید ایمیل',
  emailConfirmedSuccessfully: 'ایمیل شما با موفقیت تایید شد',
  emailOrPhoneNumber: 'ایمیل یا شماره همراه',
  enterEmail: 'لطفا ایمیل خود را وارد کنید.',
  enterNewPassword: 'لطفا رمز عبور جدید را وارد کنید',
  enterPhoneNumber: 'لطفا شماره همراه خود را وارد کنید',
  enterVerificationCode: 'کد ارسال شده به شماره {number} را وارد کنید',
  female: 'زن',
  firstName: 'نام',
  forgotPassword: 'بازیابی رمز عبور',
  fullName: 'نام کامل',
  gender: 'جنسیت',
  guestUser: 'کاربر میهمان',
  haveYouForgotPassword: 'رمز عبورتان را فراموش کرده اید؟',
  lastName: 'نام خانوادگی',
  login: 'ورود',
  loginTo: 'ورود به {cpName}',
  loginViaOtp: 'ورود با رمز یکبار مصرف',
  loginViaPassword: 'ورود با رمز عبور',
  logout: 'خروج',
  male: 'مرد',
  nationalCode: 'کد ملی',
  newPassword: 'رمز عبور جدید',
  otherLoginMethods: 'دیگر روش های ورود',
  password: 'رمز عبور',
  passwordConfirm: 'تکرار رمز عبور',
  phoneNumber: 'شماره همراه',
  phoneNumberConfirmed: 'تایید شماره همراه',
  phoneNumberConfirmedSuccessfully: 'شماره همراه  شما با موفقیت تایید شد',
  pleaseCheckYourInbox: 'لطفا ایمیل تان را چک کنید.',
  profile: 'اطلاعات شخصی',
  profileUpdated: 'حساب کاربری به روز رسانی شد',
  register: 'ثبت نام',
  registerNow: 'هم اکنون ثبت نام کنید!',
  registerSuccessful: 'شما با موفقیت ثبت نام کردید',
  resendCode: 'دریافت مجدد کد تایید',
  resendEmail: 'دریافت مجدد ایمیل',
  resetPassword: 'تنظیم مجدد رمز عبور',
  resetPasswordEmailSentTo: 'ایمیل بازیابی به آدرس "{email}" ارسال گردید.',
  resetPasswordViaEmail: 'بازیابی رمز عبور به کمک ایمیل',
  resetPasswordViaSms: 'بازیابی رمز عبور به کمک شماره همراه',
  sendEmail: 'ارسال ایمیل',
  sendSms: 'ارسال پیامک',
  signInToYourAccount: 'وارد حساب کاربری خود شوید',
  signUp: 'ثبت نام',
  signUpMessage: 'هنوز ثبت نام نکرده اید؟ روی دکمه زیر کلیک کنید.',
  suspend: 'تعلیق',
  unsuspend: 'خروج از تعلیق',
  userName: 'نام کاربری',
  verificationCode: 'کد تایید',
  verificationCodeSent: 'کد تایید به شماره {number} ارسال شد',
  verify: 'تایید',
  verifyPhoneNumber: 'تایید شماره همراه',
  yourEmailHasChanged: 'ایمیل شما تغییر کرد',
  yourPasswordHasChanged: 'رمز عبور شما تغییر کرد',
  yourPhoneNumberHasChanged: 'شماره همراه شما تغییر کرد',
  zipCode: 'کد پستی'
}
